export type JuvenileProps = {
  personalHistory: Array<string>;
  riskFactors: Array<string>;
};

export type JuvenilePropsByAge = {
  [age: string]: JuvenileProps;
};

export enum FileDownloadModes {
  DOWNLOAD = 'attachment',
  VIEW = 'inline',
}

export enum DownloadFileTypes { // = POLICY_DOC_TYPES & CSV
  HTML = 'html',
  PDF = 'pdf',
  JPEG = 'jpeg',
  CSV = 'csv',
}

export type StreamableDoc = {
  _id?: string;
  name?: string;
  type: DownloadFileTypes;
  doc?: string;
  fileNameWithExtension: string;
  docS3?: string | Buffer;
};

export enum ProductType {
  TERM = 'Term',
  WHOLE = 'Whole',
  JOINTAPP = 'JointApp',
}

export enum ExamVendor {
  APPS = 'APPS',
  ExamOne = 'ExamOne',
}

export enum PolicyTypes {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export type StateKeyValuePairs = {
  [stateCode: string]: string;
};

export enum PayerTypeOptions {
  entity = 'entity',
  anotherPerson = 'anotherPerson',
  insured = 'insured',
  owner = 'owner',
}

export interface S4RealConfigs {
  wsUsername: string;
  wsPassword: string;
  acctNum: string;
  url: string;
  host: string;
}

//this moved here from '../../../haven/public/js/common/Enums';
export enum AddressTypeCode {
  Home = 'HM',
  Work = 'WK',
  Other = 'OT',
}

/*
This enum is created to populate pii_s1 table's createdByType column
But it can be used for any table's createdByType.
 */
export enum UserEntitlement {
  AGENT = 'AGENT', // for a DB record initiated by a financial advisor
  AGENT_PROXY = 'AGENT_PROXY', // for a DB record initiated by an advisor's proxy
  OPS_PROXY = 'OPS_PROXY', // for a DB record initiated by the production support team
  DUAL_ROLE = 'DUAL_ROLE', // for a DB record initiated by an advisor who logged in with DUAL_ROLE
  CUSTOMER = 'CUSTOMER', // for a DB record initiated by a customer/client
  MIGRATION = 'MIGRATION', // for a DB record inserted through migration
  SUPER_AGENT = 'SUPER_AGENT', // for a DB record initiated  by a Super Agent user from Radmin
}

export type LoggedInUserInfo = {
  userId: string;
  entitlement: UserEntitlement;
};

export enum TrusteeTypes {
  INDIVIDUAL = 'Individual',
  ENTITY = 'Entity',
}

export type Address = {
  street: string;
  line1: string;
  line2: string;
  city: string;
  state: string;
  zip: string;
  country?: string;
};

export type TPolicyAdminPartyInfo = {
  id: string;
  partyId: string;
  name: string;
  address: Address;
  phone: {
    number: string;
    type: string;
  };
  email: string;
};

export enum SphinxReturnTypes {
  SUCCESS = 'success',
  ERROR = 'error',
  BLOCKED = 'blocked',
}

export type ObfuscationProperty = {
  type: string;
  prop: string;
  shouldObfuscate: boolean;
};
